<template>
  <div class="text-center">
    <v-dialog
      v-model="displaySelf"
      width="540"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2">
          {{ 'Пополнение баланса' }}
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="amount"
            label="сумма"
            type="number"
            required
          />

          <v-divider />
          <v-divider />

          <v-card-actions>
            <v-btn
              text
              @click="$emit('onCloseRefillAmountModal', false)"
            >
              Отменить
            </v-btn>
            <v-spacer />
            <!--            <v-btn-->
            <!--              color="success"-->
            <!--              :disabled="!isValidAmount"-->
            <!--              text-->
            <!--              @click="requestRefillAmount"-->
            <!--            >-->
            <!--              Сформировать счет-->
            <!--            </v-btn>-->
            <v-btn
              color="success"
              :disabled="!isValidAmount"
              text
              @click="refillAmount"
            >
              пополнить баланс
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

export default {
  name: 'OrganizationRefillAmount',
  props: {
    displaySelf: {
      type: Boolean,
      default: false
    },
    organization: {
      type: Object,
    }
  },
  data () {
    return {
      name: null,
      amount: null
    }
  },
  computed: {
    isValidAmount () {
      return !!this.amount && parseFloat(this.amount) > 0
    },
  },
  methods: {
    refillAmount () {
      this.save()
    },
    requestRefillAmount () {
      this.save()
    },
    async save () {
      const model = {
        id: this.organization.id,
        amount: parseFloat(this.amount)
      }
      try {
        this.showPageLoader()

        const response = await this.$store.dispatch(
          'organization/refillAmount',
          model
        )
        this.hidePageLoader()
        this.showSuccessNotification('Баланс успешно пополнен', 'success')
        this.$emit('onAmountRefilled')
        return response
      } catch (error) {
        this.showErrorNotification('Ошибка при пополнении баланса', 'error')
        this.hidePageLoader()
      }
    },
  }
}
</script>
